import Splide from '@splidejs/splide';
export const init = () => {
    initCarousel();
    const observer = new MutationObserver(() => {
        initCarousel();
    });
    observer.observe(document.querySelector('.main'),{
        childList: true,
        subtree: true
    });
}
function initCarousel() {
    if (document.querySelector('.carousel_type-4')) {
        const carousel4 = document.querySelectorAll('.carousel_type-4:not([data-js-initialized])');
        carousel4.forEach((item) => {
            item.dataset.jsInitialized = true;
            const splideCarousel4 = new Splide(item, {
                arrows: false,
                pagination: true,
                autoplay: false,
                interval: 2000,
                perPage: 1,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
                drag: false,
            },);
            splideCarousel4.mount();
            
            const arrowLeft = item.querySelector('.s-review--slider__button--prev');
            const arrowRight = item.querySelector('.s-review--slider__button--next');
            const { Controller } = splideCarousel4.Components;
            if (Controller.getPrev() === Controller.getNext()) {
                arrowLeft.parentElement.classList.add('hidden');
            }
            splideCarousel4.on('move', (newIndex) => {
                switch (newIndex) { 
                    case 0: 
                        arrowLeft.classList.add('disabled'); 
                        arrowRight.classList.remove('disabled');
                        break;
                    case Controller.getEnd():
                        arrowRight.classList.add('disabled');  
                        arrowLeft.classList.remove('disabled');
                        break;
                    default:
                        arrowLeft.classList.remove('disabled');
                        arrowRight.classList.remove('disabled');  
                } 
            });
    
            arrowLeft.addEventListener('click', () => splideCarousel4.go('<'));
            arrowRight.addEventListener('click', () => splideCarousel4.go('>'));
        });
    }
}